"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const Input_1 = __importDefault(require("@/components/Input"));
const style_1 = require("./style");
function UsersFilterView({ value, onChange }) {
    return (react_1.default.createElement(FormControl_1.default, { variant: "standard" },
        react_1.default.createElement(style_1.DescriptionTitle, { variant: "h4" }, "Enter a name below to filter users"),
        react_1.default.createElement(Input_1.default, { value: value, label: "Name", name: "users-filter", helperText: "", fullWidth: true, size: "small", role: "input", id: "users-filter", onChange: onChange })));
}
exports.default = UsersFilterView;
